import React, { useEffect, useContext, useState, forwardRef } from 'react';
import Api from '../../../api';
import Avatar from '../../../components/Avatar';
import { AdminContext } from '../../../context/AdminContext';
import ToolbarIcons from '../../../icons/toolbar';
import Cookies from 'js-cookie';
import CheckToken from '../../../functions/CheckToken';
import Loader from '../../../components/Loader';
import blanckUser from '../../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../../assets/imgs/blank-group-picture.png';

import AppIcons from '../../../icons';
import UserMoreBox from '../../../components/UserMoreBox';
import AppInput from '../../../components/AppInput';
import findMessageTypes from '../../../functions/FindMessageType';

const ChatBar = forwardRef((props, ref) => {
  const {
    themeColor,
    userChannelId,
    setUserChannelId,
    direction,
    setUpdateSocket,
    privateUsers,
    setPrivateUsers,
    setSharedUser,
    sharedUser,
    setActiveAudio,
    setActiveMessage,
    openBox,
    setopenBox,
    setShowSearch,
    setShowAbsolute,
    activeUser,
    setOpenCreateGroup,
  } = useContext(AdminContext);
  // const [openBox, setopenBox] = useState();

  // const clickItem = (item, user) => {
  //   if (item?.id == 1) {
  //     pinFuncton(user);
  //   }
  //   if (item?.id == 2) {
  //     deleteFunction(user);
  //   }
  //   if (item?.id == 3) {
  //     blockFunction(user);
  //   }
  // };

  // const pinFuncton = (x) => {
  //   console.log('xxxxxxxx', x);
  //   Api.pinUser(x?.users?.[0]?.id)
  //     .then((res) => {
  //       setUpdateSocket('user');
  //       setopenBox(false);
  //     })
  //     .catch((err) => {});
  // };
  // const deleteFunction = (x) => {
  //   console.log(
  //     'xx',
  //     x?.users?.[0]?.channelUser?.channelId ==
  //       sharedUser?.users?.[0]?.channelUser?.channelId
  //   );

  //   Api.deleteUser(x?.id)
  //     .then((res) => {
  //       // setUpdateSocket('user');
  //       setopenBox(false);
  //       if (
  //         x?.users?.[0]?.channelUser?.channelId ==
  //         sharedUser?.users?.[0]?.channelUser?.channelId
  //       ) {
  //         setSharedUser();
  //       }
  //       if (x?.users?.[0]?.channelUser?.channelId == userChannelId) {
  //         props?.setMessages([]);
  //         Api.privateChatUsersChat()
  //           .then((res) => {
  //             if (res?.data?.response?.length != 0) {
  //               setUserChannelId(
  //                 res?.data?.response?.[0]?.users?.[0]?.channelUser?.channelId
  //               );
  //             } else {
  //               setUserChannelId();
  //             }
  //             props?.setActiveUser(res?.data?.response?.[0]);
  //           })
  //           .catch((err) => {});
  //       } else {
  //         setUpdateSocket('user');
  //       }
  //     })
  //     .catch((err) => {});
  // };
  // const blockFunction = (x) => {
  //   // Api.blockUser(x?.users?.[0]?.channelUserId)
  //   //   .then((res) => {
  //   //     setUpdateSocket('user');
  //   //     setopenBox(false);
  //   //   })
  //   //   .catch((err) => {});
  //   ref?.current?.emit(
  //     'private:blockUser',
  //     { channelId: x?.users?.[0]?.channelUser?.channelId },
  //     (data) => {
  //       // setUpdateSocket('user');
  //       // setopenBox(false);
  //     }
  //   );
  //   // if (x?.block == 0) {
  //   //   ref.current.emit(
  //   //     'private:disconnect',
  //   //     { channelId: userChannelId },
  //   //     (message) => {}
  //   //   );
  //   // }
  // };
  console.log(
    'users',
    props?.users,
    privateUsers?.[0]?.users?.[0]?.id,
    sharedUser,
    privateUsers
  );
  function isJSON(str) {
    try {
      console.log('kkkkkkkkkkkkkk', !!str);
      return JSON.parse(str);
    } catch (e) {
      return false;
    }
  }
  // ${
  //   themeColor == 'white' ? ' whiteThemeBoxShadow' : ' grayThemeBoxShadow'
  // }
  return (
    <div
      className={`chat__sidebar relative ${
        props?.showUsers ? 'flex-02' : 'hidden'
      } chatbar ${direction == 'rtl' ? 'right-0' : 'left-0'} headerBg`}
      id="sidebar"
    >
      <div
        className={
          themeColor == 'white' ? 'usersBorderWhite' : 'usersBorderGray'
        }
      >
        <div className={`flex flex-row justify-between items-center w-full`}>
          {/* <p className="chat__header">{props?.content?.chatPage?.navTitle}</p> */}
          {/* <AppInput
            className={`w-full chatBarInput`}
            placeholder={props?.content?.search}
            onFocus={() => {
              props?.setActiveUser();
              setUserChannelId();
              setShowSearch(true);
            }}
          /> */}
          {/* <div
            onClick={() => {
              props?.setShowUsers(false);
            }}
            className={`closeBtn`}
          >
            <ToolbarIcons.CloseIcon
              width={'10px'}
              height={'10px'}
              className={`cursor-pointer`}
            />
          </div> */}
        </div>
        <div className="chat__users usersColor">
          {props?.chatTypePrivate ? (
            <>
              {' '}
              {privateUsers?.map((user, index) => (
                <div
                  className={`flex flex-row justify-between items-center h-auto w-auto my-[5px] cursor-pointer ${`userBoxStyle`} relative ${
                    user?.users?.[0]?.channelUser?.uuid ==
                      props?.activeUser?.users?.[0]?.channelUser?.uuid &&
                    'activeUserBox'
                  }`}
                  key={index}
                  onClick={() => {
                    if (
                      user?.users?.[0]?.channelUser?.uuid !=
                      props?.activeUser?.users?.[0]?.channelUser?.uuid
                    ) {
                      ref.current.emit(
                        'private:disconnect',
                        {
                          uuid: userChannelId,
                          typeId: activeUser?.typeId,
                          roomId: activeUser?.id,
                        },
                        (message) => {}
                      );
                    props?.setLoadingFileButton(false)
               
                      // ref.current.disconnect();
                      props?.setMessages([]);
                      setUserChannelId(user?.users?.[0]?.channelUser?.uuid);
                      props?.setActiveUser();
                      props?.setReplyValue({ id: '' });
                      // setActiveMessage('');
                      // setActiveAudio();
                      if (window?.innerWidth < 650) {
                        props?.setShowUsers(false);
                        setShowAbsolute(false);
                      }
                    }
                  }}
                >
                  <div className={`flex flex-row justify-start items-center `}>
                    {/* {user?.typeId == 3 && ( */}
                    <>
                      <Avatar
                        width={34}
                        height={34}
                        containerclassName={`cursorDefault relative`}
                        className={`cursorDefault`}
                        src={
                          user?.users?.[0]?.channelUser?.image?.name
                            ? user?.users?.[0]?.channelUser?.image?.name
                            : user?.typeId == 2
                            ? blankGroup
                            : blanckUser
                        }
                        local={!user?.users?.[0]?.channelUser?.image?.name}
                      >
                        {user?.users?.[0]?.channelUser?.statusId == 1 && (
                          <div
                            className={`${'onlineUser'} ${
                              direction == 'rtl'
                                ? 'onlineUserRtl'
                                : 'onlineUserLtr'
                            }`}
                          ></div>
                        )}
                        {user?.typeId == 2 && (
                          <div
                            className={`groupInChatbar ${
                              direction == 'ltr'
                                ? 'groupInChatbarRtl'
                                : 'groupInChatbarLtr'
                            }`}
                          >
                            <AppIcons.GroupIcon fill={`#fff`} />
                          </div>
                        )}
                      </Avatar>
                      <div
                        className={`flex flex-col justify-center items-start w-auto h-auto `}
                      >
                        <p
                          className={` ${
                            direction == 'rtl' ? 'text-right' : 'text-left'
                          } mr-[5px] chatbarUsername`}
                        >
                          {user?.users?.[0]?.channelUser?.channelName
                            ? user?.users?.[0]?.channelUser?.channelName
                            : user?.users?.[0]?.channelUser?.username}
                        </p>

                        <p
                          className={`${
                            direction == 'rtl' ? 'text-right' : 'text-left'
                          } mr-[5px] lastMessage`}
                        >
                          {user?.lastChat?.typeId != 1
                            ? props?.content?.newMessage
                            : findMessageTypes(user?.lastChat) == 'file'
                            ? props?.content?.newFile
                            : user?.lastChat?.message}
                        </p>
                      </div>
                    </>
                    {/* // )} */}
                    {/* {user?.typeId == 2 && (
                      <>
                        <Avatar
                          width={34}
                          height={34}
                          containerclassName={`cursorDefault relative`}
                          className={`cursorDefault`}
                          src={
                            user?.image?.name ? user?.image?.name : blanckUser
                          }
                          local={!user?.image?.name}
                        ></Avatar>
                        <p className={`text-right mr-[5px]`}>{user?.title}</p>
                      </>
                    )} */}
                  </div>
                  {/* <p>{user?.users?.[0]?.channelUser?.statusId}</p> */}
                  {user?.users?.[0]?.channelUser?.uuid && (
                    <div className={`flex flex-row justify-start items-center`}>
                      {user?.users?.[0].unSeen != 0 && (
                        <div className={`unseenMessages unseenMessagesColor`}>
                          <div className={`my-auto`}>
                            {user?.users?.[0]?.unSeen < 10
                              ? user?.users?.[0]?.unSeen
                              : '9' + '+'}
                          </div>
                        </div>
                      )}
                      {user?.pin == 1 && <AppIcons.pinIcon />}
                      {/* <UserMoreBox
                        user={user}
                        openBox={openBox}
                        setopenBox={setopenBox}
                        content={props?.content}
                        clickItem={clickItem}
                      /> */}
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : (
            <>
              {props?.users?.map((user, index) => (
                <div
                  className={`flex flex-row justify-start items-center h-auto w-auto my-[5px]`}
                  key={index}
                >
                  <Avatar
                    width={24}
                    height={24}
                    containerclassName={`cursorDefault`}
                    className={`cursorDefault`}
                    src={
                      user?.channelUser?.image?.name
                        ? user?.channelUser?.image?.name
                        : user?.typeId == 2
                        ? blankGroup
                        : blanckUser
                    }
                    local={!user?.channelUser?.image?.name}
                  />
                  <p className={`text-left mr-[5px]`}>
                    {user?.channelUser?.channelName
                      ? user?.channelUser?.channelName
                      : user?.channelUser?.username}
                  </p>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <div
        className={`createGroupButton cursor-pointer ${
          direction == 'rtl' ? 'createGroupButtonRtl' : 'createGroupButtonLtr'
        }`}
        onClick={() => {
          setOpenCreateGroup(true);
        }}
      >
        <AppIcons.GroupIcon width={'40px'} height={'40px'} fill="#fff" />
      </div>
    </div>
  );
});

export default ChatBar;
